import React, { useEffect, useState } from "react";
import { connect, useDispatch } from "react-redux";
import { axiosGet } from "../../../utils/common/axios";
import { getAllProduct } from "../../../store/actions";
import InsertDriveFileOutlinedIcon from "@mui/icons-material/InsertDriveFileOutlined";
import { Button } from "@mui/material";
import { PDFDownloadLink } from "@react-pdf/renderer";
import { InvoiceCartBundle } from "../pdfTemplates/invoice/InvoiceCartBundle";
import toast from "react-hot-toast";
import styles from "./pdfDownload.module.scss"
import colors from "../../../colors";



// USE THE FOLLOWING WHILE CALLING THE PDF DOWNLOAD BUTTON

const PdfDownload = ({ orderDetails, auth, btnLabel, products }) => {
  const [orderData, setOrderData] = useState({});
  const [productData, setProductData] = useState({});
  const [qrImage, setQrImage] = useState(null);
  // const [data, getFormatedTime] = useFormatedDate();
  const [states, setStates] = useState([]);
  const dispatch = useDispatch();

  const getOrderDetails = () => {
    setOrderData((pre) => {
      return { ...pre, deliveryAddress: pre?.address };
    });
  };

  useEffect(() => {
    console.log("down",orderDetails)
    const getStates = async () => {
      try {
        const { status, data } = await axiosGet("/state/all");
        if (status === 200) setStates(data);
      } catch (e) {
        toast.error("Error fetching states");
      }
    };
    getStates();
    setOrderData(orderDetails);
  }, []);

  useEffect(() => {
    dispatch(getAllProduct());
  }, []);

  return (
    <React.Fragment>
      {!orderData.deliveryAddress ? (
        <Button
          variant="outlined"
          startIcon={
            <InsertDriveFileOutlinedIcon
              style={{ color: colors.$primaryColor }}
            />
          }
          style={{ width: "180px", fontSize: "12px" }}
          color="success"
          classes={{ contained: styles.pdfButton }}
          // disabled={loading ? true : false}
          onClick={() => getOrderDetails()}
        >
          {" "}
          Generate Invoice
        </Button>
      ) : (
        <PDFDownloadLink
          document={
            <InvoiceCartBundle
              orderData={orderData}
              states={states}
              products={products}
            />
          }
          fileName={`${orderData?.invoiceNumber}-Print Receipt.pdf`}
        >
          {({ loading }) =>
            loading ? (
              `Loading...`
            ) : (
              <Button
                startIcon={
                  <InsertDriveFileOutlinedIcon
                    style={{ color: "white" }}
                  />
                }
                variant="contained"
                color="success"
                classes={{ contained: styles.pdfButton }}
                disabled={loading ? true : false}
              >
                {btnLabel || "Download Invoice"}
              </Button>
            )
          }
        </PDFDownloadLink>
      )}

      {/* <PDFViewer width={1400} height={1050}>
        <InvoiceCartBundle
          orderData={{
            ...dummy,
            deliveryAddress: dummy?.address,
          }}
          states={states}
          products={products}
        />
      </PDFViewer> */}
    </React.Fragment>
  );
};

const mapStateToProps = (state, props) => {
  return {
    auth: state.login.auth,
    products: state?.product?.products,
  };
};

export default connect(mapStateToProps, null)(PdfDownload);
